export default __webpack_public_path__ + "static/media/sliderImg2.a701aee8.jpg";